import * as _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function omitDeep(input: any, props: string[]): any {
    function omitDeepOnOwnProps(obj): unknown {
        if (typeof input === 'undefined') {
            return input;
        }
        if (!_.isArray(obj) && !_.isObject(obj)) {
            return obj;
        }
        if (Array.isArray(obj)) {
            return omitDeep(obj, props);
        }
        const o = {};
        for (const [key, value] of Object.entries(obj)) {
            o[key] = !_.isNil(value) ? omitDeep(value, props) : value;
        }

        return _.omit(o, props);
    }
    if (arguments.length > 2) {
        // eslint-disable-next-line prefer-rest-params
        props = Array.prototype.slice.call(arguments).slice(1);
    }
    if (Array.isArray(input)) {
        return input.map(omitDeepOnOwnProps);
    }

    return omitDeepOnOwnProps(input);
}
